var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_804_8562",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 19,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.903 3.47153C18.2759 3.09863 18.2759 2.49405 17.903 2.12116C17.5301 1.74826 16.9255 1.74827 16.5526 2.12117L2.80289 15.8712C2.42999 16.2441 2.43 16.8487 2.8029 17.2216C3.1758 17.5944 3.78039 17.5944 4.15328 17.2215L6.13125 15.2435C8.36247 16.1143 10.916 16.178 13.3229 15.2319C15.8645 14.2319 17.8812 12.2235 18.8812 9.67354C18.2282 8.02272 17.1585 6.61414 15.8201 5.55444L17.903 3.47153ZM13.4816 7.89301L12.1701 9.2045C12.1995 9.35802 12.2145 9.515 12.2145 9.67354C12.2145 10.3366 11.9511 10.9725 11.4823 11.4413C11.0134 11.9101 10.3776 12.1735 9.71452 12.1735C9.556 12.1735 9.39903 12.1585 9.24553 12.1292L7.93407 13.4407C8.48557 13.7013 9.09288 13.8402 9.71452 13.8402C10.8196 13.8402 11.8794 13.4012 12.6608 12.6198C13.4422 11.8384 13.8812 10.7786 13.8812 9.67354C13.8812 9.05187 13.7423 8.44453 13.4816 7.89301ZM9.71452 3.42354C10.7767 3.42354 11.8102 3.59549 12.7838 3.91685L10.9928 5.70781C10.5835 5.57586 10.1526 5.50687 9.71452 5.50687C8.60945 5.50687 7.54964 5.94586 6.76824 6.72726C5.98684 7.50866 5.54785 8.56847 5.54785 9.67354C5.54785 10.1116 5.61684 10.5426 5.74881 10.952L3.22151 13.4793C2.0746 12.4762 1.14423 11.1907 0.547852 9.67354C2.03118 5.92354 5.66452 3.42354 9.71452 3.42354ZM7.94675 7.90577C8.36942 7.48311 8.92784 7.22742 9.51953 7.18115L7.22212 9.47861C7.26838 8.8869 7.52407 8.32845 7.94675 7.90577Z",
    fill: "#006FFD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_804_8562)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.547852,
    y: 0.506714,
    width: 18.3333,
    height: 18.3333,
    fill: "#8D8D8D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.f482b0a3ffa8a8d5834d971703f83f70.svg";
export { ForwardRef as ReactComponent };